namespace Solovis.Reports.ReportControlHelpers {

    export class WaitManager {

        public reportControl: Solovis.Reports.ReportControl;
        public _isWaiting: boolean;
        public _waitDiv: JQuery;
        public _showWaitDivIntervalHandle;

        constructor(
            options: {
                reportControl: Solovis.Reports.ReportControl
            }
        ) {
            this.reportControl = options.reportControl;

            this._isWaiting = false;

            this._showWaitDivIntervalHandle = null;
            this._waitDiv = null;
        }

        // NOTE: appears unused
        public isWaiting() {
            return this._isWaiting;
        }

        public waitingHasBegun() {
            // Called by ReportControl to let us know that it is waiting on something.
            // if (Solovis.UX.Utils.isNewUxEnabled()) {
            //     Solovis.UX.Utils.showLoader();
            //     return     
            // }

            var self = this;

            this._isWaiting = true;

            if (ReportControl._log) {
                console.log("ReportControl.WaitManager: waitingHasBegun");
            }

            if (!this._showWaitDivIntervalHandle) {
                // Since we have a 500ms interval, the wait div won't show up unless the report
                // loading takes at least 500ms.
                this._showWaitDivIntervalHandle = setInterval(
                    function () {
                        self._showOrHideWaitDiv();
                    },
                    500);
            }
        }

        public waitingHasEnded() {
            // if (Solovis.UX.Utils.isNewUxEnabled()) {
            //     Solovis.UX.Utils.hideLoader();
            //     return;
            // }
            
            // Called by ReportControl to let us know that it is done waiting.
            this._isWaiting = false;

            if (ReportControl._log) {
                console.log("ReportControl.WaitManager: waitingHasEnded");
            }

            this._showOrHideWaitDiv();
        }

        public _showOrHideWaitDiv() {
            if (!this._isWaiting) {
                if (this._showWaitDivIntervalHandle) {
                    clearInterval(this._showWaitDivIntervalHandle);
                    this._showWaitDivIntervalHandle = null;
                }

                if (this._waitDiv) {
                    $(this._waitDiv).remove();
                    this._waitDiv = null;

                    if (ReportControl._log) {
                        console.log("ReportControl.WaitManager: hiding wait div");
                    }
                }
                return;
            }

            if (!this._waitDiv) {
                var container = this.reportControl.controlHost ? this.reportControl.controlHost.container : null;
                if (container) {
                    var zIndexForWaitDiv = 1 + Solovis.UI.DomHelper.findZIndexOfTopLevelParent(container);

                    var offset = $(container).offset();

                    this._waitDiv = $("<div>")
                        .css("width", 100)
                        .css("height", 100)
                        .css("z-index", zIndexForWaitDiv)
                        .css("pointer-events", "none");
                    this._waitDiv
                        .css("position", "absolute")
                        .css("left", offset.left + 20)
                        .css("top", offset.top + 20);

                    var animationDiv = Solovis.UI.StockAnimations.createSpinningCircles({
                        diameter: "100px",
                        top: "50%",
                        left: "50%",
                        showShadow: true
                    })
                        .appendTo(this._waitDiv);

                    this._waitDiv.appendTo(document.body);

                    if (ReportControl._log) {
                        console.log("ReportControl.WaitManager: showing wait div");
                    }
                }
            }
            else {
                // See if we need to relocate the wait div.
                var container = this.reportControl.controlHost ? this.reportControl.controlHost.container : null;
                if (container) {
                    var offset = $(container).offset();

                    this._waitDiv
                        .css("left", offset.left + 20)
                        .css("top", offset.top + 20);
                }
            }
        }
    }

}
